import omit from 'lodash/omit';
import { entitySelectors } from '../entity';

export const userHasAccessToSpaEntity = (state, entity) => {
  const property = entitySelectors.getProperty(state);
  const guest = state?.guest?.guest;
  const spaEntityModules = property?.modulesExcludingDisabled?.spa?.features?.[entity];
  const entityVisibleToAll = spaEntityModules?.features?.visibleToAll?.enabled;
  const entityVisibleToRegistered = spaEntityModules?.features?.visibleToRegistered?.enabled;
  const entityVisibleToMembers = spaEntityModules?.features?.visibleToMembers?.enabled;
  const guestIsMember = guest?.spaMembership;
  const guestIsRegistered = !!guest?.id;
  return (
    entityVisibleToAll ||
    (entityVisibleToRegistered && guestIsRegistered) ||
    ((entityVisibleToRegistered || entityVisibleToMembers) && guestIsMember)
  );
};

export const guestSelectors = {
  getGuest: (state) => state.guest.guest,
  getLoggedInGuestWithDelivery: (state) => {
    if (state.guest.guest) {
      return {
        ...state.guest.guest.delivery,
        ...omit(state.guest.guest, ['delivery', 'payment']),
      };
    }
    return null;
  },
  userHasAccessToSpaEntity,
};
